<main id="main">
    <div class="overlay"></div>
    <router-outlet></router-outlet>
    <app-player></app-player>
    <msc-navigation-progress></msc-navigation-progress>
    <msc-player-light></msc-player-light>
    <msc-window-embed></msc-window-embed>
    <msc-common-toast></msc-common-toast>
    <app-floating-chat></app-floating-chat>
</main>

<!-- modal logout // cerrar sesion -->
<msc-common-modal size="30vw" #modalLogout [title]="'words.logout' | translate" class="modal-logout">
    <ng-template>
        <p style="margin-top:-1.5rem" class="text-gray-500 ">{{ "words.logout-description" | translate }}</p>
        <div class="flex items-center mt-5 space-x-5 justify-end">
            <msc-button palette="primary" (click)="modalLogout.onClose()" class="modal-logout__cancel" style="border-radius: 9999px;">{{
                "common.cancel" | translate
            }}</msc-button>
            <msc-button
                palette="primary"
                (click)="logout(); modalLogout.onClose()"
                class="modal-logout__confirm"
                style="background-color: var(--v2-color-primary-500); border-radius: 9999px; color: white;"
                >{{ "common.confirm" | translate }}</msc-button
            >
        </div>
    </ng-template>
</msc-common-modal>
